import React, { useEffect } from "react";
import {
  Input,
  Row,
  Card,
  Select,
  Form,
  Col,
  Typography,
  Button,
  Layout,
  Image,
  notification,
} from "antd";
import { isEmpty, isPlainObject, isUndefined } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import actions from "../../redux/studentDetails/actions";
import config from "../../Services/apiEndPoints";
import "../../Screens/form.css";

const { Option } = Select;
const { TextArea } = Input;
const { Header } = Layout;

export default function SchoolDetails() {
  const [schoolform] = Form.useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { successMessage, errorMessage, actionType, studentDetails } =
    useSelector((state) => state.student);
  const typeOfUser =
    sessionStorage.getItem("typeOfUser") || localStorage.getItem("typeOfUser");
  const student_Id = localStorage.getItem("Student_Id");

  useEffect(() => {
    if (!isEmpty(student_Id) && !isUndefined(student_Id)) {
      dispatch(
        actions.getStudentPersonalDetails(
          `${config.studentGet}?studentId=${student_Id}`
        )
      );
    }
  }, []);

  useEffect(() => {
    if (isPlainObject(studentDetails) && !isEmpty(studentDetails)) {
      schoolform.setFieldsValue({
        ...studentDetails,
      });
    }
  }, [studentDetails]);

  useEffect(() => {
    if (actionType === actions.STUDENT_DETAILS_UPDATE_SUCCESS) {
      notification.success({
        message: successMessage,
      });
      const student_Id = localStorage.getItem("Student_Id");
      const payload = { student_id: student_Id };
      dispatch(actions.resetStudentPersonalDetails());
      dispatch(actions.createEnrolledExam(config.enrollExam, payload));
    } else if (actionType === actions.STUDENT_DETAILS_UPDATE_ERROR) {
      notification.error({
        message: errorMessage,
      });
      dispatch(actions.resetStudentPersonalDetails());
    }
  }, [actionType, successMessage, errorMessage]);

  useEffect(() => {
    if (actionType === actions.ENROLLED_EXAMS_CREATE_SUCCESS) {
      // notification.success({
      //   message: successMessage,
      // });
      navigate("/dashboard");
    } else if (actionType === actions.ENROLLED_EXAMS_CREATE_ERROR) {
      // notification.error({
      //   message: errorMessage,
      // });
      navigate("/dashboard");
      dispatch(actions.resetStudentPersonalDetails());
    }
  }, [actionType, successMessage, errorMessage]);

  const classList = [
    "I",
    "II",
    "III",
    "IV",
    "V",
    "VI",
    "VII",
    "VIII",
    "IX",
    "X",
  ];

  const handleSave = async () => {
    // try {
    //   const values = await schoolform.validateFields();
    //   values["id"] = student_Id;
    //   dispatch(actions.updateStudentDetails(config.studentUpdate, values));
    // } catch (e) {
    //   console.log(e);
    // }
    navigate("/SchoolDetailsForm")
  };

  return (
    <>
      <div>
        <Header style={{ backgroundColor: "#ffb948", height: "75px" }}>
          <Row align="middle" gutter={16}>
            <Col xs={8} sm={6} md={4} lg={6}>
              <a
                href="https://sriramanavami.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Image
                  preview={false}
                  src="/favicon.ico"
                />
              </a>
            </Col>
          </Row>
        </Header>
      </div>
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage:
            "url(https://easy-peasy.ai/cdn-cgi/image/quality=80,format=auto,width=700/https://fdczvxmwwjwpwbeeqcth.supabase.co/storage/v1/object/public/images/889e1b27-b887-4082-a896-b7921854ef78/722b627e-72e3-4422-80a7-aab78de2256e.png)",
          backgroundPosition: "center",
          backgroundSize: "cover",
          zIndex: -1,
        }}
      ></div>
      <div
        style={{
          marginTop: "20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "100px",
        }}
      >
        <Row>
          <Card
            style={{
              width: "100%",
              maxWidth: "2000px",
              borderRadius: "8px",
              boxShadow: "0 10px 15px 0 rgba(10,1,10,10)",
            }}
          >
            <Typography.Title
              level={3}
              style={{ textAlign: "center", margin: "auto" }}
            >
              School Details
            </Typography.Title>
            <Form form={schoolform} layout="vertical">
              <Row gutter={24}>
                <Col xs={24} sm={12} md={12}>
                  <Form.Item
                    name={["school_details", "school_name"]}
                    label="School Name"
                    rules={[
                      { required: true, message: "School name is required." },
                    ]}
                  >
                    <Input
                      placeholder="Enter School Name"
                      className="custom-input"
                      disabled={
                        isPlainObject(studentDetails?.school_details) &&
                        !isEmpty(studentDetails?.school_details)
                      }
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12}>
                <Form.Item
                    name={["Branch"]}
                    label="Branch"
                  >
                    <Input
                      placeholder="Enter Branch"
                      className="custom-input"
                      disabled={
                        isPlainObject(studentDetails?.school_details) &&
                        !isEmpty(studentDetails?.school_details)
                      }
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12}>
                  <Form.Item
                    label="School Address"
                    name={["school_details", "school_address"]}
                    rules={[
                      { required: true, message: "School address is required." },
                    ]}
                  >
                    <TextArea
                      maxLength={100}
                      placeholder="Enter School Address"
                      className="custom-input"
                      disabled={
                        isPlainObject(studentDetails?.school_details) &&
                        !isEmpty(studentDetails?.school_details)
                      }
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12}>
                <Form.Item
                    name={["school_details", "pincode"]}
                    label="Pincode"
                    rules={[
                      { required: true, message: "Pincode is required." },
                    ]}
                  >
                    <Input
                      placeholder="Enter School Name"
                      className="custom-input"
                      disabled={
                        isPlainObject(studentDetails?.school_details) &&
                        !isEmpty(studentDetails?.school_details)
                      }
                    />
                  </Form.Item>

                </Col>
              </Row>
              <Row gutter={24}>
                <Col xs={24} sm={12} md={12}>
                  <Form.Item
                    name={["contact_person", "person1_name"]}
                    label="Contact Person 1 Name"
                    rules={[
                      {
                        required: true,
                        message: "Contact person 1 name is required.",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter Contact Person 1 Name"
                      className="custom-input"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12}>
                  <Form.Item
                    name={["contact_person", "person1_mobile"]}
                    label="Contact Person 2 Mobile"
                    rules={[
                      {
                        required: true,
                        message: "Contact person 1 mobile is required.",
                      },
                      {
                        pattern: /^[0-9]{10}$/,
                        message: "Please enter a valid 10-digit mobile number.",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter Contact Person 1 Mobile"
                      className="custom-input"
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col xs={24} sm={12} md={12}>
                  <Form.Item
                    name={["contact_person", "person2_name"]}
                    label="Contact Person 2 Name"
                  >
                    <Input
                      placeholder="Enter Contact Person 2 Name"
                      className="custom-input"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12}>
                  <Form.Item
                    name={["contact_person", "person2_mobile"]}
                    label="Contact Person 2 Mobile"
                  >
                    <Input
                      placeholder="Enter Contact Person 2 Mobile"
                      className="custom-input"
                    />
                  </Form.Item>
                </Col>
              </Row>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between", // Space between the buttons
                }}
              >
                <Button
                  type="default"
                  style={{ width: "45%" }} // Adjust width as needed
                  onClick={() => navigate("/personalDetails")} // Replace with your desired action
                  className="custom-button"
                >
                  Back
                </Button>
                <Button
                  type="primary"
                  style={{
                    width: "45%", // Adjust width as needed
                    backgroundColor: "#ffb948", // Button color matches header
                    color: "white",
                    border: "none", // Optional: remove border
                  }}
                  onClick={handleSave}
                >
                  Save
                </Button>
              </div>
            </Form>
          </Card>
        </Row>
      </div>
    </>
  );
}
